import { useDispatch, useSelector } from 'react-redux';
import { changeEditorStatus } from '../../actions';
import { STATUS_PREVIEW } from '../../constants/EditorStatus';
import React from 'react';

export default function PreviewButton () {
  const canPublish = useSelector(state => state.post.uploadProgressCount === 0);
  const editorStatus = useSelector(state => state.env.editorStatus);
  const dispatch = useDispatch();

  function handlePreview () {
    if (!canPublish) {
      return;
    }
    dispatch(changeEditorStatus(STATUS_PREVIEW));
  }

  return (
    <a href="#" role="button" aria-expanded={editorStatus === STATUS_PREVIEW} className="btn_type1" onClick={handlePreview}>
      <span className="mce-ico ico_preview" />
      <span className="btn_txt">미리보기</span>
    </a>
  );
}
